import { Box, Flex, Image, Text } from '@chakra-ui/react';
import { Options, Splide, SplideSlide } from '@splidejs/react-splide';
import '@splidejs/react-splide/css';
import {
  DEFAULT_PROPERTY_IMAGE_URL,
  getPropertySource,
} from '~/apps/consumer/utils/listing.utils';

interface ListingPhotoCarouselProps {
  images: string[];
  options?: Options;
  borderRadius?: string;
}

const IMAGE_MAX_HEIGHT = '266px';

export const ListingPhotoCarousel = ({
  images,
  options,
  borderRadius = 'sm',
}: ListingPhotoCarouselProps) => {
  const defaultOptions: Options = {
    type: 'swipe',
    rewind: true,
    drag: 'free',
    snap: true,
    perPage: 5,
    perMove: 1,
    gap: '0.75rem',
    pagination: false,
    breakpoints: {
      1920: {
        perPage: 4,
        gap: '0.75rem',
      },
      1440: {
        perPage: 3,
        gap: '0.75rem',
      },
      992: {
        perPage: 2,
        gap: '0.5rem',
      },
      768: {
        perPage: 1,
        gap: '0.1rem',
      },
    },
    lazyLoad: 'nearby',
  };

  return (
    <Box width="100%">
      <Box
        _active={{
          cursor: 'grabbing',
        }}
        as={Splide}
        cursor="grab"
        options={{ ...defaultOptions, ...options }}
        onMouseDown={(e) => {
          e.stopPropagation();
        }}
      >
        {images.map((image, index) => (
          <SplideSlide key={index}>
            <Image
              alt={`photo-${index}`}
              borderRadius={borderRadius}
              fallbackSrc={DEFAULT_PROPERTY_IMAGE_URL}
              fit="cover"
              height="100%"
              maxHeight={IMAGE_MAX_HEIGHT}
              src={getPropertySource(image)}
              width="100%"
            />
            <Flex bottom={4} gap={1} position="absolute" right={4} zIndex={1}>
              <Text color="white" fontWeight="500">{`${
                index + 1
              }/${images?.length}`}</Text>
            </Flex>
          </SplideSlide>
        ))}
      </Box>
    </Box>
  );
};
